module.exports = __webpack_public_path__ + "img/toast-success.4f568253.svg";